/* Copyright (c) 2020 BuserNet Consulting LLC   All rights reserved. */
export default {
  delays: 200,
  closeButtonCaptions: {
    close: 'Close',
    finish: 'Finish',
  },
  'app.dashboard': {
    steps: [
      {
        target: '#btn-meteo-selector',
        content: 'Tap this menu to configure the Airport view.',
        params: {
          enableScrolling: false,
        },
      },
      {
        target: '#day-night-indicator-meteo',
        content:
          'This bar shows the time of day (using either Zulu time or the local time on your device). The gray background indicates night and the yellow is day.',
        params: {
          enableScrolling: false,
        },
      },
      {
        target: '#flightweather-strip-meteo',
        content: 'This bar shows the weather conditions for the given time at this airport.',
        params: {
          enableScrolling: false,
        },
      },
      {
        target: '#flightrules-strip-meteo',
        content:
          'This bar shows the flight condition for the given time at this airport. Green is VFR, blue is MVFR, red is IFR, and pink is LIFR.\n\n'
          + 'Cloud coverage is indicated by the pie chart within each circle.',
        params: {
          enableScrolling: false,
        },
      },
      {
        target: '#ceilingChartMeteo',
        content:
          'This graph shows clouds aloft. White rectangles mean a high probability of clouds, gray rectangles mean a low probability of clouds, and blue means blue skies :-)\n\n'
          + 'Freezing level (if present) is indicated by the blue dashed line. Two dashed lines at a given time means a temperature inversion is present.',
        params: {
          enableScrolling: false,
        },
      },
      {
        target: '#precepitationChartMeteo',
        content:
          'This graph shows precipitation. The blue line is inches of liquid precipitation. The blue area chart shows chance of precipitation. Orange is thunderstorms, red is severe thunderstorms, and pink is snow. Maroon is freezing precipitation.',
        offForLandscape: true,
        params: {
          enableScrolling: false,
        },
      },
      {
        target: '#windChartMeteo',
        content:
          'This graph shows winds. The orange line shows wind speed in knots. The wind barbs show wind direction and speed. The arrow on the wind barb points to the direction the wind is blowing.\n\n'
          + 'The pink area graph shows crosswind in knots using the most favorable runway available at this airport.\n\n'
          + 'The blue bars show peak wind gusts at the surface.',
        offForLandscape: true,
        params: {
          enableScrolling: false,
        },
      },
      {
        target: '#tempChartMeteo',
        content:
          'This graph shows temperature and humidity at the surface. The area chart shows temperature, and the blue line shows humidity.',
        offForLandscape: true,
        params: {
          enableScrolling: false,
        },
      },
      {
        target: '#btn-fav',
        content:
          'Tap this icon to mark this view as a favorite. It will appear in the Spork Menu under Favorites.',
        params: {
          enableScrolling: false,
        },
      },
    ],
  },
  'app.routeprofile': {
    steps: [
      {
        target: '#btn-route-selector',
        content: 'Tap this menu to configure the route profile view.',
        params: {
          enableScrolling: false,
        },
      },
      {
        target: '#day-night-indicator-route',
        content:
          'This bar shows the time of day (using either Zulu time or the local time on your device). The gray background indicates night and the yellow is day.',
        params: {
          enableScrolling: false,
        },
      },
      {
        target: '#flightweather-strip-route',
        content:
          'This bar shows the weather conditions for the given time at corresponding airport.',
        params: {
          enableScrolling: false,
        },
      },
      {
        target: '#flightrules-strip-route',
        content:
          'This bar shows the flight condition for the given time at corresponding airport. Green is VFR, blue is MVFR, red is IFR, and pink is LIFR.\n\n'
          + 'Cloud coverage is indicated by the pie chart within each circle.',
        params: {
          enableScrolling: false,
        },
      },
      {
        target: '#route-ceiling-chart',
        content:
          'This graph shows clouds aloft. White rectangles mean a high probability of clouds, gray rectangles mean a low probability of clouds, and blue means blue skies :-)\n\n'
          + 'Freezing level (if present) is indicated by the blue dashed line. Two dashed lines at a given time means a temperature inversion is present.',
        params: {
          enableScrolling: false,
        },
      },
      {
        target: '#route-precepitation-chart',
        content:
          'This graph shows precipitation. The blue line is inches of liquid precipitation. The blue area chart shows chance of precipitation. Orange is thunderstorms, red is severe thunderstorms, and pink is snow. Maroon is freezing precipitation.',
        offForLandscape: true,
        params: {
          enableScrolling: false,
        },
      },
      {
        target: '#route-temperature-strip',
        content: 'This strip shows temperature and humidity at the surface.',
        offForLandscape: true,
        params: {
          enableScrolling: false,
        },
      },
      {
        target: '#footer-slider-label-button-route',
        content: 'Tap this menu to configure the departure time.',
        offForLandscape: true,
        params: {
          enableScrolling: false,
        },
      },
      {
        target: '#bn-etd-slider-routeprofile',
        content: 'Move the ETD Finder left and right to change departure time.',
        params: {
          enableScrolling: false,
        },
      },
      {
        target: '#btn-fav-btn-route-selector',
        content:
          'Tap this icon to mark this view as a favorite. It will appear in the Spork Menu under Favorites.',
        params: {
          enableScrolling: false,
        },
      },
      {
        target: '#btn-layer-btn-route-selector',
        content: 'Tap this icon to filter out layers of chart.',
        params: {
          enableScrolling: false,
        },
      },
    ],
  },
  'app.leafletmapview': {
    steps: [
      {
        target: '#routeSelector',
        content: 'Tap this menu to configure the map view.',
        params: {
          enableScrolling: false,
        },
      },
      {
        target: '.footer-slider-label-button',
        content: 'Tap this menu to configure the departure time.',
        offForLandscape: true,
        params: {
          enableScrolling: false,
        },
      },
      {
        target: '#bn-etd-slider-leaflet',
        content: 'Move the ETD Finder left and right to change departure time.',
        params: {
          enableScrolling: false,
        },
      },
      {
        target: '#btn-fav-btn-route-selector-leaflet',
        content:
          'Tap this icon to mark this view as a favorite. It will appear in the Spork Menu under Favorites.',
        params: {
          enableScrolling: false,
        },
      },
      {
        target: '#btn-layer-btn-route-selector-leaflet',
        content: 'Tap this icon to filter out layers of chart.',
        params: {
          enableScrolling: false,
        },
      },
    ],
  },
  'app.mapview': {
    steps: [
      {
        target: '#btn-route-selector-map',
        content: 'Tap this menu to configure the map view.',
        params: {
          enableScrolling: false,
        },
      },
      {
        target: '.bottomTab .mapview-etd-tab',
        content: 'Tap this tab to configure the departure time.',
        offForLandscape: true,
        params: {
          enableScrolling: false,
        },
      },
      {
        target: '.bottomTab .mapview-radar-tab',
        content: 'Tap this tab to configure the radar time.',
        offForLandscape: true,
        disabled: true,
        params: {
          enableScrolling: false,
        },
      },
      {
        target: '.bottomTab .mapview-flight-tab',
        content: 'Tap this menu to configure the flight time.',
        offForLandscape: true,
        params: {
          enableScrolling: false,
        },
      },
      {
        target: '#bn-etd-slider-mapview',
        content: 'Move the ETD Finder left and right to change departure time.',
        params: {
          enableScrolling: false,
        },
      },
      {
        target: '#btn-fav-btn-route-selector-map',
        content:
          'Tap this icon to mark this view as a favorite. It will appear in the Spork Menu under Favorites.',
        params: {
          enableScrolling: false,
        },
      },
      {
        target: '#btn-layer-btn-route-selector-map',
        content: 'Tap this icon to filter out layers of chart.',
        params: {
          enableScrolling: false,
        },
      },
    ],
  },
  'app.gridview': {
    steps: [
      {
        target: '#btn-route-selector-grid',
        content: 'Tap this menu to configure the grid view.',
        params: {
          enableScrolling: false,
        },
      },
      {
        target: '.row-1',
        content: 'Each block shows the flight condition for the given airport at the given time.',
        params: {
          enableScrolling: false,
        },
      },
      {
        target: '.col-1',
        content: 'Tap to see meteogram view of this airport.',
        params: {
          enableScrolling: false,
        },
      },
      {
        target: '#footer-slider-label-button-grid',
        content: 'Tap this menu to configure the departure time.',
        offForLandscape: true,
        params: {
          enableScrolling: false,
        },
      },
      {
        target: '#bn-etd-slider-gridview',
        content: 'Move the ETD Finder left and right to change departure time.',
        params: {
          enableScrolling: false,
        },
      },
      {
        target: '#btn-fav-btn-route-selector-grid',
        content:
          'Tap to mark this view as favorite. It will appear in the Spork Menu under Favorites.',
        params: {
          enableScrolling: false,
        },
      },
    ],
  },
  'app.weather': {
    title: '7 Day screen help',
    steps: [
      {
        target: '#btn-weather-selector',
        content: 'Tap this menu to configure the 7-Day view.',
      },
      {
        target: '#col-1-0',
        content: 'Day for which weather record is listed.',
      },
      {
        target: '#col-2-0',
        content: 'Max/Min temperature and wind speed on this day.',
      },
      {
        target: '#col-3-0',
        content: 'Precipitation on this day.',
      },
      {
        target: '#col-4-0',
        content: 'Short weather summary for this day.',
      },
      {
        target: '#btn-fav-weather',
        content:
          'Tap this icon to mark this view as a favorite. It will appear in the Spork Menu under Favorites.',
      },
    ],
  },
  'app.settings': {
    steps: [
      {
        target: '#timezonePref',
        content: 'Select timezone preference, device default or Zulu timezone.',
      },
      {
        target: '#tempUnitPref',
        content: 'Select temperature unit preference, fahrenheit or celsius.',
      },
      {
        target: '#groundSpeedPref',
        content: 'Set your prefered ground speed here.',
      },
      {
        target: '#weatherSourceApiPref',
        content: 'Click here for advanced configuration.',
      },
    ],
  },
};
